import {
  CreateButton,
  Datagrid,
  FunctionField,
  Record,
  TextField,
  useListContext,
} from "react-admin";
import trailerGpsProviders from ".";
import permissionNames from "../../../common/auth/access-control/permissionNames";
import { useActionPermissions } from "../../../common/auth/useActionPermissions";
import { TrailerTrackingProviderDto } from "../../../common/data/service-proxies";
import { DefaultProLogsList } from "../../common/list/DefaultProLogsList";
import { ProLogsEmpty } from "../../common/list/ProLogsEmpty";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import IndeterminateCheckBoxIcon from "@material-ui/icons/IndeterminateCheckBox";
import { Box, useTheme, Theme } from "@material-ui/core";

import "../../common/styles/list-style.css";
import { ActionsField } from "../../common/data-grid-fields/ActionsField";
import { DeleteRecordMenuItem } from "../../common/data-grid-fields/DeleteRecordMenuItem";

interface Props {}

export const TrailerGpsProvidersList = (props: Props) => {
  const permissions = useActionPermissions();
  const theme: Theme = useTheme();

  const ListActions = () => {
    const { basePath } = useListContext();
    const permissions = useActionPermissions();
    return (
      <>
        {permissions &&
          permissions[permissionNames.admin.trailerGpsProviders.main] &&
          permissions[permissionNames.admin.trailerGpsProviders.create] && (
            <CreateButton basePath={basePath} />
          )}
      </>
    );
  };

  return (
    <div className="content-container">
      <DefaultProLogsList
        empty={<ProLogsEmpty iconType={trailerGpsProviders.icon} />}
        className="content-list"
        title="resources.admin-trailer-gps-providers.name"
        bulkActionButtons={false}
        actions={<ListActions />}
        {...props}
      >
        <Datagrid>
          <TextField
            source="provider"
            label="resources.admin-trailer-gps-providers.labels.provider"
          />
          <FunctionField<TrailerTrackingProviderDto & Record>
            source="status"
            headerClassName="centered-content"
            label="resources.common.labels.active"
            render={(record) => (
              <Box className="centered-content">
                {record?.status === "Active" ? (
                  <CheckBoxIcon
                    className={record.status}
                    style={{
                      color: theme.palette.success.main,
                    }}
                  />
                ) : (
                  <IndeterminateCheckBoxIcon
                    className={record?.status}
                    style={{
                      color: theme.palette.error.main,
                    }}
                  />
                )}
              </Box>
            )}
          />
          <ActionsField
            editable={() =>
              permissions &&
              permissions[permissionNames.admin.trailerGpsProviders.main] &&
              permissions[permissionNames.admin.trailerGpsProviders.update]
            }
            canActivateOrDeactivate={() =>
              permissions &&
              permissions[permissionNames.admin.trailerGpsProviders.main] &&
              permissions[permissionNames.admin.trailerGpsProviders.update]
            }
          >
            {permissions &&
              permissions[permissionNames.admin.trailerGpsProviders.main] &&
              permissions[permissionNames.admin.trailerGpsProviders.delete] && (
                <DeleteRecordMenuItem />
              )}
          </ActionsField>
        </Datagrid>
      </DefaultProLogsList>
    </div>
  );
};
